import React, { useEffect } from "react";
import { Modal, Box, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomInput from "../CustomInput";
import { useForm } from "react-hook-form";
import s from "./styles.module.css";

const CustomModal = ({
  open,
  onClose,
  title,
  fields,
  onConfirm,
  loading,
  initialData,
  mode,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (open) {
      if (mode === "edit" && initialData) {
        console.log("Reset редактирование");
        reset(initialData);
      } else if (mode === "add") {
        console.log("Reset добавление");
        reset({});
      }
    }
  }, [open, mode, initialData, reset]);

  const handleFormSubmit = (data) => {
    onConfirm(data);
    reset({});
  };
  const handleClose = () => {
    reset({});
    onClose();
  };
  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6">{title}</Typography>
          <CloseIcon onClick={handleClose} style={{ cursor: "pointer" }} />
        </div>
        <form onSubmit={handleSubmit(handleFormSubmit)}>
          <div className={s.inputBlock}>
              {fields &&
                  fields.map((field) => (
                      <div key={field.name} className={s.inputWrapper}>
                          {field.type === "select" ? (
                              <div className={s.selectWrapper}>
                                  <label>{field.label}</label>
                                  <select
                                      {...register(field.name, field.validation || {})}
                                      className={s.selectInput}
                                      defaultValue=""
                                  >
                                      <option value="">Выберите...</option>
                                      {field.options.map((option) => (
                                          <option key={option.value} value={option.value}>
                                              {option.label}
                                          </option>
                                      ))}
                                  </select>
                              </div>
                          ) : (
                              <CustomInput
                                  name={field.name}
                                  label={field.label}
                                  placeholder={field.placeholder}
                                  type={field.type || "text"}
                                  error={!!errors[field.name]}
                                  helperText={errors[field.name]?.message || ""}
                                  inputRef={register(field.name, field.validation || {}).ref}
                                  {...register(field.name, field.validation || {})}
                              />
                          )}
                          {errors[field.name] && <p className={s.errorText}>{errors[field.name].message}</p>}
                      </div>
                  ))}

          </div>
          <div className="centerLoading">
            {loading ? (
              <div className="loader"></div>
            ) : (
              <button type="submit" className="saveButton">
              Добавить
              </button>
            )}
          </div>
        </form>
      </Box>
    </Modal>
  );
};

export default CustomModal;
